<template>
  <div id="settings">

    <header class="inner-head border-transparent h-16">
      <div class="flex justify-between">
        <h2 class="sub-head-title">Year Group Display</h2>
      </div>

    </header>


    <div class="w-full h-12 ml-8">
        <p>
          Setup and alter the default Year Group heading titles. This will alter the display only for all areas within the platform where Year Group titles are shown.
        </p>
      </div>

    <div class="assessmentconfig w-11/12 ml-4 flex">
      <div class="bg-white w-full pb-3 mb-10 ">

        <div class="px-4">
        <form
          id="form-years"
          v-on:submit.prevent="saveSettings()"
          ref="formYears"
        >

          <!-- Section -->
          <section>
            <div
              class="flex flex-wrap -mx-3 mb-4"
              v-for="row in years"
              :key="row.key"
            >
              <div class="w-full px-3">
                <label
                  class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-500 text-xs
                    font-bold
                    mb-2
                  "
                  for="grid-title"
                >
                  {{ row.name }}
                </label>
                <input
                  :value="yearsConfigValue(row.value).title"
                  @input="
                    yearsConfigValue(row.value).title = $event.target.value
                  "
                  class="
                    appearance-none
                    block
                    w-full
                    bg-gray-100
                    text-gray-700
                    border border-gray-200
                    rounded
                    py-3
                    px-4
    
                    leading-tight
                    focus:outline-none focus:bg-white focus:border-gray-500
                  "
                  id="grid-title"
                  type="text"
                  placeholder="Enter Year Title"
                  required=""
                />
              </div>
            </div>
          </section>
        </form>

        

        <div class="w-full flex justify-end content-baseline space-x-10 text-right border-t">
          <div class="w-10/12 flex justify-end">

            <p v-if="hasCompleted" class="text-green-500 mt-4">
              Settings configuration saved.
            </p>
               
            <p v-if="errored" class="text-red-500 mt-4">
              We are not able to retrieve this information at the moment, please try
              back later.
            </p>

            <div
              style="text-align: center"
              class=""
              v-if="loading"
            >
              <i class="spinner fa fa-spinner fa-spin text-sm"></i>
              <p>Saving</p>
            </div>
          </div>
         <button
              @click="submitForm()"
              type="button"
              class="publish-button hover:opacity-75 mt-4"
            >
              Publish Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { settingsMixin } from "@/mixins/settingsMixin.js";


export default {
  name: "assessmentconfig",
  mixins: [settingsMixin],
  computed: {
    ...mapGetters({ currentUser: "currentUser", access: "currentAccess" }),
   
  },
  watch: {
  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {
   
  },
  methods: {
    changeViewParamType() {},
    yearsConfigValue(value) {
      return this.yearsList.find((v) => v.value == value);
    },
    submitForm() {
      
      if (this.$refs.formYears.requestSubmit === undefined) {
        this.saveSettings();
      } else {
        this.$refs.formYears.requestSubmit();
      }
      
    },
 
  },
  components: {
  },
};
</script>


<style scoped>

.header-subnav {
  @apply text-gray-600  mr-1 font-medium;
}


.header-subnav.selected {
  @apply text-gray-800 my-2 font-semibold  bg-white border-none rounded-lg;
}

h5 {
  text-transform: uppercase;
}

.actions {
  float: right;
}

.criteria {
  padding-bottom: 4.5em !important;
}

.criteria.top {
  padding-top: 0px !important;
  margin-bottom: 0px;
}

.criteria li span {
  font-size: 1.1em;
  color: #4a4a4a;
  display: inline;
  float: left;
}

.criteria input {
  margin-bottom: 40px;
  margin-top: -7px;
}

.lean-right {
  text-align: right;
}

.dragme {
  cursor: move;
  font-size: 130%;
}

.small {
  font-size: 90%;
  color: #f56a6a;
  width: 20px;
  display: inline-block;
}

.list-complete-item {
  transition: all 1s;
}

.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
  height: 0px;
  margin-top: 0px;
  padding: 0px;
  border: solid 0px;
}

.list-complete-item input[type="text"] {
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

.list-complete-item td {
  vertical-align: middle !important;
}

.list-complete-item td input[type="checkbox"] + label {
  padding-left: 0em !important;
}

.list-complete-item td .fa-square {
  font-size: 180% !important;
  padding-left: 0.5em;
}

.selected-row {
  @apply bg-blue-100  !important;
}
</style>

